import TemplateManager from "./templates/TemplateManager";

import ic_funnel_1 from "../../assets/funnel/type/thumbnail_funnel_1.png";
import ic_funnel_2 from "../../assets/funnel/type/thumbnail_funnel_2.png";
import ic_funnel_3 from "../../assets/funnel/type/thumbnail_funnel_3.png";
import { COLUMN_CODE, TableManger, TABLES } from "../../managers/TableManger";
import HtmlGenerator from "../page_designer/HtmlGenerator";
import Utility from "../../utility/Utility";
import FunnelService from "../../services/funnel";
import AppManager from "../../managers/AppManager";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";

export const FUNNEL_TYPE = {
  LANDING_PAGE: "Email template Funnel",
  MAGNET_FUNNEL: "Magnet Funnel",
  COLLECT_EMAIL: "Collect Email Funnel",
};

export default class FunnelManager {
  static funnelDataFromAPI = null;
  static selectedFunnelData = null;
  static currentStepIndex = null;

  static status = {
    ACTIVE: [1],
    IN_ACTIVE: [2],
  };

  static getAllFunnelTypes() {
    return [
      {
        type: FUNNEL_TYPE.LANDING_PAGE,
        title: "Email template Funnel",
        description:
          "Create a beautiful email template using pre build templates. Used by 43K Teams",
        icon: ic_funnel_3,
      },
      {
        type: FUNNEL_TYPE.COLLECT_EMAIL,
        title: "Collect Email Funnel",
        description:
          "Find out what your customer actually wants. Connect with them. Used by 3K Teams",
        icon: ic_funnel_2,
      },
      {
        type: FUNNEL_TYPE.MAGNET_FUNNEL,
        title: "Lead Magnet Funnel",
        description:
          "A traditional ecommerce website that pushed people into core funnel. Used by 22.4K Teams",
        icon: ic_funnel_1,
      },
    ];
  }

  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////

  static getNewFunnelData(funnelType, selectedTemplateIndex) {
    switch (funnelType) {
      case FUNNEL_TYPE.LANDING_PAGE:
        return TemplateManager.getLandingPageFunnelTemplate(
          selectedTemplateIndex
        );
      case FUNNEL_TYPE.COLLECT_EMAIL:
        return TemplateManager.getContactFunnelTemplate(selectedTemplateIndex);
      case FUNNEL_TYPE.MAGNET_FUNNEL:
        return TemplateManager.getLeadMagnetFunnelTemplate(
          selectedTemplateIndex
        );
      default:
        return TemplateManager.getLandingPageFunnelTemplate();
    }
  }

  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////

  static setFunnelDataFromAPI(data) {
    FunnelManager.funnelDataFromAPI = data;
    FunnelManager.setCurrentFunnelData(
      data ? FunnelManager.getFunnelJSONData() : null
    );
  }
  static getFunnelDataFromAPI() {
    return FunnelManager.funnelDataFromAPI;
  }

  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////
  static isFunnelDataAvailable() {
    return FunnelManager.funnelDataFromAPI;
  }

  static getFunnelRecordId() {
    if (!FunnelManager.isFunnelDataAvailable()) {
      return null;
    }

    return FunnelManager.getFunnelDataFromAPI().data._id;
  }

  static setCurrentFunnelData(data) {
    FunnelManager.selectedFunnelData = data;
    FunnelManager.setCurrentStepIndex(0);
  }
  static getCurrentFunnelData() {
    return FunnelManager.selectedFunnelData;
  }

  static getCurrentFunnelHTMLData() {
    const htmlGenerator = new HtmlGenerator();
    const funnelData = FunnelManager.getCurrentFunnelData();
    const hash = funnelData[0].templateData.hash;
    let htmlData = [];
    funnelData.forEach((funnel, index) => {
      const templateData = funnel.templateData;
      const html = htmlGenerator.getHTML(
        templateData.designElements,
        templateData.scripts,
        templateData.metaData,
        hash,
        funnel.pageType,
        index < funnelData.length - 1 ? funnelData[index + 1].path : null
      );
      htmlData.push({
        path: funnel.path,
        html: Utility.encodeHTML(html),
      });
    });
    return htmlData;
  }

  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////

  static setCurrentStepIndex(index) {
    FunnelManager.currentStepIndex = index;
  }
  static getCurrentStepIndex() {
    return FunnelManager.currentStepIndex;
  }
  static getCurrentStepData() {
    return FunnelManager.getStepData(FunnelManager.currentStepIndex || 0);
  }
  static getStepData(index) {
    return FunnelManager.getCurrentFunnelData()
      ? FunnelManager.getCurrentFunnelData()[index]
      : null;
  }
  static addNewStep(data) {
    FunnelManager.getCurrentFunnelData().push(data);
    FunnelManager.setCurrentStepIndex(
      FunnelManager.getCurrentFunnelData().length - 1
    );
  }
  static deleteCurrentStep() {
    FunnelManager.getCurrentFunnelData().splice(
      FunnelManager.currentStepIndex,
      1
    );
    if (FunnelManager.currentStepIndex !== 0) {
      FunnelManager.currentStepIndex -= 1;
    }
  }

  static updateCurrentStepData(data) {
    FunnelManager.getCurrentFunnelData()[FunnelManager.currentStepIndex] = data;
  }

  static updateCurrentStepTemplateData(data) {
    let stepData = FunnelManager.getCurrentStepData();
    stepData.templateData = data;
  }

  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////

  static getAllFunnelSteps() {
    if (FunnelManager.selectedFunnelData) {
      let arr_steps = [];

      FunnelManager.getCurrentFunnelData().forEach((obj, index) => {
        let step = {};
        step["title"] = obj.title;
        step.onClick = () => {
          FunnelManager.setCurrentStepIndex(index);
          // RouteManager.navigateToPage(PAGE_ROUTES.FUNNEL_BUILDER + obj.path);
        };
        arr_steps.push(step);
      });

      if (FunnelManager.isFunnelDataAvailable()) {
        arr_steps.push({
          title: "Publish details",
          onClick: () => {
            RouteManager.navigateToPage(
              PAGE_ROUTES.FUNNEL_DOMAIN +
                "/" +
                FunnelManager.getFunnelRecordId()
            );
          },
        });
      }

      return arr_steps;
    }
    return [];
  }

  static isStepPathAvailable(path, ownPath) {
    return !FunnelManager.getCurrentFunnelData().some(
      (obj) => obj.path === path && obj.path !== ownPath
    );
  }

  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////

  static getDirectLink() {
    if (!FunnelManager.isFunnelDataAvailable()) {
      return "URL not found";
    }
    let directLink = FunnelManager.getFunnelDataFromAPI().data.cells[
      FunnelManager.getColumnId(COLUMN_CODE.FUNNEL.DIRECT_LINK)
    ];

    return AppManager.generateDirectLink(directLink);
  }
  static getFunnelJSONData() {
    let jsonData = FunnelManager.getFunnelDataFromAPI().data.cells[
      FunnelManager.getColumnId(COLUMN_CODE.FUNNEL.JSON_DATA)
    ];

    return Utility.decodeJSON(jsonData);
  }

  static fetchFunnelDataById(recordId, callback) {
    FunnelService.getData(
      recordId,
      (response) => {
        FunnelManager.setFunnelDataFromAPI({ data: response });
        callback && callback();
      },
      (error) => {}
    );
  }

  static getColumnId(columnCode) {
    return TableManger.getColumnId(TABLES.FUNNEL, columnCode);
  }

  static getRequestToSaveFunnel(funnelData) {
    let data = {};
    data[this.getColumnId(COLUMN_CODE.FUNNEL.NAME)] = funnelData.funnelName;
    data[
      this.getColumnId(COLUMN_CODE.FUNNEL.HTML_DATA)
    ] = FunnelManager.getCurrentFunnelHTMLData();
    data[this.getColumnId(COLUMN_CODE.FUNNEL.JSON_DATA)] = Utility.encodeJSON(
      FunnelManager.getCurrentFunnelData()
    );
    data[
      this.getColumnId(COLUMN_CODE.FUNNEL.HASH)
    ] = FunnelManager.getCurrentFunnelData()[0].templateData.hash;
    data[this.getColumnId(COLUMN_CODE.FUNNEL.CUSTOM_DOMAIN)] =
      funnelData.domain;
    data[this.getColumnId(COLUMN_CODE.FUNNEL.VISITORS)] = 0;
    data[this.getColumnId(COLUMN_CODE.FUNNEL.CLICKS)] = 0;
    data[this.getColumnId(COLUMN_CODE.FUNNEL.LEADS)] = 0;
    data[this.getColumnId(COLUMN_CODE.FUNNEL.STATUS)] =
      FunnelManager.status.ACTIVE;
    data[this.getColumnId(COLUMN_CODE.FUNNEL.PUBLISHED)] = true;
    return data;
  }

  static getRequestToUpdateFunnel() {
    let data = {};
    data[
      this.getColumnId(COLUMN_CODE.FUNNEL.HTML_DATA)
    ] = FunnelManager.getCurrentFunnelHTMLData();

    data[this.getColumnId(COLUMN_CODE.FUNNEL.JSON_DATA)] = Utility.encodeJSON(
      FunnelManager.getCurrentFunnelData()
    );
    data[this.getColumnId(COLUMN_CODE.FUNNEL.PUBLISHED)] = true;
    return data;
  }

  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////
}
